import CrearContrasena from "../pages/CrearContrasena";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { http, tokenStore, esPublica } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [cambio, setCambio] = useState(false);
  useEffect(() => {
    if (!tokenStore.get() || esPublica()) return setUser(false);
    http.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const login = async (email, password) => {
    const r = await http.post("/auth/login", { email, password });
    tokenStore.set(r.data.access_token, r.data.refresh_token);
    setUser(r.data.user);
    return r.data.user;
  };
  const quickLogin = async (user_id) => {
    const r = await http.post("/auth/quick-login", { user_id });
    tokenStore.set(r.data.access_token, r.data.refresh_token);
    localStorage.setItem("quick_login", "1");
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = useCallback(async (motivo) => {
    await http.post("/auth/logout", { motivo: typeof motivo === "string" ? motivo : "" }).catch(() => null);
    tokenStore.clear();
    localStorage.removeItem("quick_login");
    setUser(false);
  }, []);
  return <AuthCtx.Provider value={{ user, setUser, login, quickLogin, logout, cambio, setCambio }}>{children}</AuthCtx.Provider>;
};

export const QuickBanner = () => (localStorage.getItem("quick_login") ? (
  <div className="bg-[#FFF4E5] px-4 py-1 text-center text-[11px] font-semibold tracking-wide text-[#B4471F]" data-testid="quick-login-banner">Sesión por acceso rápido</div>
) : null);

export const useAuth = () => useContext(AuthCtx);

export const can = (user, ...perms) => !!user && perms.some((p) => (user.permisos || []).includes(p));
export const esAnalista = (user) => !!user && (user.role === "director" || can(user, "analisis.editar", "deals.ver_todos", "risk.acceder"));

export const RequireAuth = ({ children, role, perm, portal }) => {
  const { user, cambio } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center text-sm text-[#8C867A]" data-testid="auth-loading">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password || cambio) return <CrearContrasena />;
  if (user.role === "referenciador" && !portal) return <Navigate to="/portal" replace />;
  if (portal && user.role !== "referenciador") return <Navigate to="/" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  if (perm && !can(user, ...[].concat(perm))) return <Navigate to="/" replace />;
  return children;
};
